/**
 * Canonical user-facing product terminology.
 * Entity: capability (not prompt). Saved files: knowledge (not context).
 * Capability TYPE "Prompt" (Prompt/Skill/Agent) lives in builderCategories.js — do not replace here.
 */

export const PRODUCT_TERMS = {
  capability: {
    singular: 'capability',
    plural: 'capabilities',
    untitled: 'Untitled capability',
    titleCase: 'Capability',
    pluralTitleCase: 'Capabilities',
  },
  knowledge: {
    singular: 'knowledge',
    plural: 'knowledge',
    untitled: 'Untitled knowledge',
    titleCase: 'Knowledge',
  },
  attachKnowledge: 'Attach Knowledge',
  updateKnowledge: 'Update knowledge',
  addRemoveExistingKnowledge: 'Add / remove existing knowledge',
  addRemoveExistingCapabilities: 'Add / remove existing capabilities',
  temporaryKnowledge: 'temporary knowledge',
  knowledgeUsed: 'Knowledge used',
  knowledgeAndSupporting: 'Knowledge',
  copyCapabilityPlusKnowledge: 'Copy capability + knowledge',
  copyCapabilityText: 'Copy capability text',
  justCapabilityText: 'Just the capability text',
};

/** @param {'capability'|'knowledge'} unit @param {number} count */
export function formatSelectionCount(count, unit = 'capability') {
  if (unit === 'knowledge') {
    return count === 1 ? '1 knowledge item selected' : `${count} knowledge items selected`;
  }
  const label = count === 1 ? PRODUCT_TERMS.capability.singular : PRODUCT_TERMS.capability.plural;
  return `${count} ${label} selected`;
}
